import {NgModule} from '@angular/core';
import {TabsModule} from 'ngx-bootstrap/tabs';
import { DataTablesModule } from 'angular-datatables';
import {HttpClientModule} from '@angular/common/http';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import { FBUserSeedingComponent } from './fb-user-seeding.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {AngularMultiSelectModule} from 'angular2-multiselect-dropdown';
import { TreeGridModule } from '@syncfusion/ej2-angular-treegrid';
import {CommandColumnService, EditService, PageService, SortService, FilterService,ToolbarService } from '@syncfusion/ej2-angular-treegrid';

const routes: Routes = [
  {
    path: '',
    component: FBUserSeedingComponent,
    data: {
      title: 'Danh sách tài khoản tương tác'
    },
  }
];


@NgModule({
  imports: [
    TabsModule,
    BsDatepickerModule.forRoot(),
    FormsModule,
    CommonModule,
    DataTablesModule,
    HttpClientModule,
    ReactiveFormsModule,
    TreeGridModule,
    AngularMultiSelectModule,
    RouterModule.forChild(routes)

  ],
  //exports: [ ConfirmationModalComponent ],
  declarations: [FBUserSeedingComponent],
  //entryComponents: [ConfirmationModalComponent],
  providers: [PageService,
    SortService,
    EditService,
    CommandColumnService ,
    ToolbarService,
    FilterService]
})
export class FbUserSeedingModule {
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/fb-user-seeding/fb-user-seeding.module.ts